import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import EditSocialMediaForm from "../EditSocialMediaForm";

const EditSocialMediaModal = ({ onClose, show }) => (
  <Modal
    id="edit-social-media-modal"
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Edit Social Media Links" closeButton />
    <p className="tw-text-14d tw-text-gray-50 tw-mt-[-4px] tw-mb-[24px]">
      <b>Tip:</b> If you enter a username, we will automatically format the link for you! Social
      media links are featured on agent profile pages and the <b>/links</b> page (if you have a
      subdomain set up) of your Brivity website.
    </p>

    <EditSocialMediaForm />
  </Modal>
);

EditSocialMediaModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default EditSocialMediaModal;
